import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon } from '@iconify/react';

/**
 * 404 Not Found Page
 * Displays when user navigates to a non-existent route
 * Provides options to go back or return home
 */
export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-white flex items-center justify-center p-4">
      <div className="text-center max-w-2xl">
        {/* 404 Number */}
        <h1 className="text-[8rem] sm:text-[10rem] md:text-[12rem] font-bold text-zinc-200 leading-none select-none">
          404
        </h1>

        {/* Title */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-zinc-800 mt-4 sm:mt-6">
          {t('notFound.title')}
        </h2>

        {/* Subtitle */}
        <p className="text-lg sm:text-xl text-zinc-600 mt-3 sm:mt-4">
          {t('notFound.subtitle')}
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center items-center mt-6 sm:mt-8">
          {/* Primary Button - Go Home (Solid) */}
          <button
            type="button"
            onClick={handleGoHome}
            className="w-full sm:w-auto py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-brand text-white hover:bg-brand-dark disabled:opacity-50 disabled:pointer-events-none"
          >
            <Icon icon="lucide:home" className="shrink-0 size-4" />
            {t('notFound.backHome')}
          </button>

          {/* Secondary Button - Go Back (Outline) */}
          <button
            type="button"
            onClick={handleGoBack}
            className="w-full sm:w-auto py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-border-default bg-white text-default shadow-sm hover:bg-brand/4 disabled:opacity-50 disabled:pointer-events-none"
          >
            <Icon icon="lucide:arrow-left" className="shrink-0 size-4" />
            {t('notFound.backPrevious')}
          </button>
        </div>
      </div>
    </div>
  );
}
